import config from '../../config'

const getPersonalizationMapStatusesTypeRequest = ({ airportId }) => ({
  method: 'get',
  url: `${config.baseUrl}/${airportId}/PersonalizationMapStatuses`,
})

export default getPersonalizationMapStatusesTypeRequest
